<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container"><a id="page_iv"></a>
<img alt="images" src="images/f00iv-1.jpg"/>
</div>
<p class="fm1">W. F. OSCAR FEDERHEN</p>
<p class="fm1">Postwar portrait from a composite photograph with portraits of 116 members of the John A. Logan Post No. 127 of the Grand Army of the Republic in Salina, Kansas, c. 1911.</p>
<p class="fm2"><em class="italic">Smoky Hill Museum Object Identification Number 1946.12.1. Donated by</em></p>
<p class="fm3"><em class="italic">Cora Walker Shelton to the Smoky Hill Museum, Salina, Kansas.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_FM1.vue?6e343cd6